export function getTranslation(translations: any, path: string): string {
  if (!translations || !path) {
    return path;
  }

  if (Object.prototype.hasOwnProperty.call(translations, path)) {
    return translations[path];
  }

  let segments = path.split('.');
  let index = 0;
  let source = translations;
  while (index < segments.length) {
    if (source === null || source === undefined) {
      return path;
    }
    source = source[segments[index]];
    index++;
  }
  return source === undefined ? path : source;
}
